<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex md4 xs12 pb-2 v-for="(birth, i) in list" :key="i">
        <v-card :width="widthCard" height="180px">
          <v-layout align-center fill-height justify-center>

            <v-flex xs4 pl-2>
              <v-img
                :src="birth.photo"
                :style="`height: 110px; width: 110px; object-fit: cover; border-radius: 50%; border: 3.2px solid `+ birth.color"
              ></v-img>
            </v-flex>

            <v-flex xs8 pt-2 pb-2 style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
              <div>
                <v-flex pl-2 font-weight-bold text-14-security text-uppercase>{{birth.name}} {{birth.last_names}}</v-flex>
                <v-flex pl-2 text-14-security v-if="birth.gender">Hijo de {{birth.father }}</v-flex>
                <v-flex pl-2 text-14-security v-else>Hija de {{birth.father }}</v-flex>
                <v-flex pl-2 text-14-security>{{birth.company}}</v-flex>
                <v-flex pl-2 text-14-security>{{ birth.birthday }}</v-flex>
              </div>
              <div>
                <v-btn small round :color="birth.color" :href="`mailto:${birth.email}`">
                  <h3 class="white--text caption-security font-weight-regular">Enviar saludo</h3>
                </v-btn>
              </div>
              
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>


    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">Cargando...</div>
      <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
      <v-layout slot="no-results">
        <v-flex sm12>
          <v-card height="400px">
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                sm12
                class="text-29-security text-md-center font-weight-bold"
                style="color: #525252"
              >No hay nacimientos este mes</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  props: {
    date: {
      type: String,
      required: true
    },
    monthNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      list: [],
    };
  },
  computed: {
    widthCard() {
      if (window.innerWidth > 425) {
        return "380";
      } else {
        return "";
      }
    }
  },
  methods: {
    ...mapMutations("births", ["setBirth", "setBirths"]),
    goToShowBirth(birth) {
      this.setBirth(birth);
      this.$router.push({
        name: "birth-show",
        params: { id: birth.id }
      });
    },
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL}/births`;
      axios.get(api, { params: { page: this.page, date: this.monthNumber } }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          this.setBirths(this.list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }
};
</script>
